export const layers = {
  municipalityMask: {
    'id': 'municipality-mask',
    'type': 'fill',
    'source': 'gemeente',
    'source-layer': 'Gemeente',
    'minzoom': 10,
    'maxzoom': 16,
    'filter': ['!=', ['get', 'ID_gemeente'], -1],
    'paint': {
      'fill-color': '#217F9A',
      'fill-opacity': 0.2,
    },
  },
  selectedMunicipality: {
    'id': 'selected-gemeente-border',
    'type': 'line',
    'source': 'gemeente',
    'source-layer': 'Gemeente',
    'minzoom': 0,
    'maxzoom': 16,
    'filter': ['==', ['get', 'ID_gemeente'], -1],
    'paint': {
      'line-color': '#21697F',
      'line-width': 2,
    },
  },
};
